import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import actions from "../redux/actions/cartActions";
import { useState } from "react";
import PaymentMethods from "./PaymentMethods";

function Cart() {
  const shoppingCart = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const [updatedQty, setUpdatedQty] = useState(0);
  let totalPrice = 0;
  const navigate = useNavigate();

  const handleChange = (e, product) => {
    setUpdatedQty(e.target.value);
    dispatch(actions.addToCart(product, e.target.value));
  };

  const handleRemove = (product) => {
    dispatch(actions.removeFromCart(product));
  };

  return (
    <>
      {shoppingCart.length === 0 ? (
        <>
          <div className="d-flex align-items-center flex-column my-3 animate__animated animate__fadeIn">
            <p className="fs-5 text-center f-roboto">
              Your cart is currently empty.
            </p>
            <Link
              to="/"
              className="d-flex align-items-center justify-content-center text-decoration-none btn btn-yellow w-25 mt-3"
            >
              Go shop
            </Link>
          </div>
        </>
      ) : (
        <div className="mt-5 animate__animated animate__fadeIn">
          <table className="table table-borderless align-middle">
            <thead>
              <tr className="border-bottom f-roboto">
                <th className="product-col" scope="col">
                  Product
                </th>
                <th className="price-col text-center" scope="col">
                  Price
                </th>
                <th className="quantity-col text-center" scope="col">
                  Quantity
                </th>
                <th className="total-col text-end" scope="col">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {shoppingCart.map((product) => (
                <tr key={product.id} className="border-bottom">
                  <th scope="row" className="py-4">
                    <div className="d-flex flex-row w-75">
                      <div className="cart-product-img me-4 animate__animated animate__fadeIn product-img-container">
                        <Link to={"/product/" + product.slug}>
                          <img
                            src={
                              process.env.REACT_APP_IMAGES_URL +
                              "/" +
                              product.images.img1
                            }
                            alt={product.name}
                            className="img-fluid"
                          />
                        </Link>
                      </div>
                      <div>
                        <Link
                          className="text-decoration-none text-dark"
                          to={"/product/" + product.slug}
                        >
                          <p className="mb-0 fw-normal product-name-cart">{product.name}</p>
                        </Link>
                        <button
                          onClick={() => handleRemove(product)}
                          className="btn-remove fw-normal link-yellow f-roboto mt-3 mt-sm-2"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </th>
                  <td className="text-center f-roboto product-name-cart">${product.price}</td>
                  <td className="text-center">
                    <label htmlFor="quantity" className="visually-hidden">
                      Quantity
                    </label>
                    <input
                      onChange={(e) => handleChange(e, product)}
                      type="number"
                      min="1"
                      className="quantity-input f-roboto product-name-cart"
                      name="quantity"
                      value={product.qty ? product.qty : updatedQty}
                    />
                  </td>
                  <td className="text-end f-roboto product-name-cart">
                    ${(product.price * product.qty).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="d-flex flex-row f-roboto product-name-cart">
            <div className="col-6">
              <p>Add a note to your order</p>
              <textarea className="w-75" />
            </div>
            <div className="col-6 text-end">
              <div>
                <span className="me-5">Subtotal</span>
                <span className="ms-sm-5 f-roboto">
                  $
                  {
                    (totalPrice = shoppingCart
                      .reduce(
                        (acc, product) => acc + product.qty * product.price,
                        0
                      )
                      .toFixed(2))
                  }
                </span>
              </div>
              <div className="mt-3">
                <p>Taxes and shipping calculated at checkout</p>
              </div>
            </div>
          </div>
          <div className="row justify-content-end">
            <div className="col-lg-5 p-0">
              <PaymentMethods />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Cart;
